
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { ALU } from "@consts/aalu";
import type { IProduct } from "@type/products";
import { getAllAluByParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import { Breadcrumb } from "../../../components/breadcrumb";
interface IProductPage {
    products: IProduct[];
}
const AluSlidingDoorsPage: NextPage<IProductPage> = ({ products }) => (<>
    <NextSeo languageAlternates={[
        {
            href: "https://knsokna.pl/alu/sliding-doors",
            hrefLang: "x-default",
        },
        { href: "https://knswindows.com/alu/sliding-doors", hrefLang: "en" },
        { href: "https://knsokna.pl/alu/sliding-doors", hrefLang: "pl" },
        { href: "https://knsfenster.de/alu/sliding-doors", hrefLang: "de" },
        { href: "https://kns-okna.eu/alu/sliding-doors", hrefLang: "cs" },
        { href: "https://knsfinestre.it/alu/sliding-doors", hrefLang: "it" },
        { href: "https://knsfenetres.fr/alu/sliding-doors", hrefLang: "fr" },
        { href: "https://knsokna.eu/alu/sliding-doors", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
        <Breadcrumb />
        <Products products={products}/>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products } = await getAllAluByParent(ALU.SLIDING_DOORS[LOCALE as keyof typeof ALU.SLIDING_DOORS], LOCALE);
    return {
        props: {
            products,
        },
    };
};
export default AluSlidingDoorsPage;

    async function __Next_Translate__getStaticProps__1a19cd2bf3d__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/alu/sliding-doors/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bf3d__ as getStaticProps }
  